export const FADE_OUT_DURATION = 200;
export const BASE_DELAY = 1200;
export const TOPIC_DELAY_INCREMENT = 300;

export const getAnimationDelay = (index: number, topicsLength = 0): string => {
  switch (index) {
    case 0: // Overview text delay
      return "0ms";
    case 1: // Space name delay
      return "300ms";
    case 2: // Summary text delay
      return "600ms";
    case 3: // Takeaways title delay
      return "900ms";
    case 4: // Sources delay
      return `${BASE_DELAY + (topicsLength + 1) * TOPIC_DELAY_INCREMENT}ms`;
    case 5: // Footer delay
      return `${BASE_DELAY + (topicsLength + 2) * TOPIC_DELAY_INCREMENT}ms`;
    default:
      // For topic items - start after takeaways title
      return `${BASE_DELAY + (index - 4) * TOPIC_DELAY_INCREMENT}ms`;
  }
};
